import { getStoreVisibilityLabel } from '../../../context-api/api-services/StoreManagement.service';

export function formatDetailValue(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value);
}

export function formatBoolFromNumber(value) {
  if (value == null || value === '') return '—';
  if (value === 1 || value === true || value === '1') return 'Yes';
  if (value === 0 || value === false || value === '0') return 'No';
  return formatDetailValue(value);
}

export function formatDateTime(value) {
  if (value == null || value === '') return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatPhone(value) {
  if (value == null || value === '') return '—';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return String(value);
}

export function formatCoordinates(coords) {
  if (!Array.isArray(coords) || coords.length < 2) return '—';
  return `${coords[1]}, ${coords[0]}`;
}

export function formatMealOffering(mealOffering) {
  if (!mealOffering || typeof mealOffering !== 'object') return '—';
  const labels = {
    main_dish: 'Main dish',
    side: 'Side',
    kids_menu: 'Kids menu',
    complementry: 'Complimentary',
  };
  const enabled = Object.entries(mealOffering)
    .filter(([, v]) => v === 1 || v === true)
    .map(([k]) => labels[k] || k.replace(/_/g, ' '));
  return enabled.length ? enabled.join(', ') : 'None';
}

export function formatVisibility(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (n === 1) return 'Hidden';
  if (n === 2) return 'Limited';
  if (n === 3) return 'Live';
  return String(value);
}

export function formatAccountStatus(status) {
  if (typeof status === 'boolean') return status ? 'Active' : 'Inactive';
  return formatDetailValue(status);
}

export function formatStoreVisibilityStatus(raw) {
  if (raw == null || raw === '') return '—';
  return getStoreVisibilityLabel(String(raw).trim().toLowerCase().replace(/\s+/g, '_'));
}

export function formatCurrency(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return `$${n.toFixed(2)}`;
}

export function formatPercent(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return `${n}%`;
}

export function titleCase(value) {
  if (value == null || value === '') return '—';
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
